<template>
  <div>
    <banner />
    <ProgressCom />
    <Project />
    <Honor />
    <OwFooter />
  </div>
</template>
<script>
import Banner from "./components/banner";
import ProgressCom from "./components/progressCom";
import Project from "./components/project";
import Honor from "./components/honor";
import OwFooter from "@/components/ow-footer";
export default {
  components: {
    Banner,
    ProgressCom,
    Project,
    Honor,
    OwFooter
  }
};
</script>
